import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';

import TinyInputStore from '@src/components/tiny-input/store';
import AntdMessage from '@src/components/antd/message';
import { autobind } from 'core-decorators';
import lockAsync from '@src/utils/lock-async';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import { useRequest, useUnmount } from 'ahooks';
import { isUndefined } from '@src/utils/type-utils';
import { useEffect } from 'react';
import { message } from 'antd';
import getUtmSource from '@src/utils/get-utm-source';
import { getLocales } from '@src/global-locales/get-page-locales-data';

import useMount from '@src/utils/hooks/use-mount';
import EmailTipsStore from '@src/business-components/appointment-modal/overseas/components/email-tips/store';
import { $$tracker } from '@src/tracker';

class AppointmentModalStore extends BaseModalStore {
  @observable closeCallback = noop;
  // 协议勾选状态
  @observable protocolCheckState = false;
  // 当前主机tab标准
  @observable channelId = 0;

  emailTipsStore = new EmailTipsStore();

  //emailInputStore

  /**
   * 手机号码输入框
   * @type {TinyInputStore}
   */
  phoneInputStore = new TinyInputStore({
    onChange: value => {
      let val = value?.target?.value;
      if (!isUndefined(val)) {
        val = val.replace(/[^A-Za-z0-9\u4e00-\u9fa5 ]/g, '');
        // val = val.replace(/\D/g, '');
        val = val.slice(0, 11);
      }
      this.phoneInputStore.value = val;
    }
  });

  /**
   * 手机号码输入框
   * @type {TinyInputStore}
   */
  emailInputStore = new TinyInputStore({
    onChange: value => {
      let val = value?.target?.value;
      if (!isUndefined(val)) {
        val = val.replace(/[^A-Za-z0-9\u4e00-\u9fa5\D ]/g, '');
        // val = val.replace(/\D/g, '');
        // val = val.slice(0, 11);
      }
      this.emailInputStore.value = val;
    }
  });

  /**
   * 验证码输入框
   * @type {TinyInputStore}
   */
  smsInputStore = new TinyInputStore();
  @observable submitLock = false;
  /**
   * 预约成功
   */
  @observable appointmentSuccessCallBack = noop;
  @observable appointmentSuccessState = false;
  // 预约成功后自动关闭的倒计时
  @observable appointmentSuccessCloseTime = 5;
  // 手机栏错误提示
  @observable phoneInputError = '';
  // 邮箱错误提示
  @observable emailInputError = '';
  // 验证码栏错误提示
  @observable smsInputError = '';
  // 更新config
  @observable updataConfig = noop;
  // 是否是新预约
  @observable is_new = false;

  @observable startTime = null; //开启记录时间
  @observable endTime = null; // 结束记录时间
  @observable isTimerStarted = false; // 记录是否开始计时
  @observable totalTime = 0; // 总计预约时间

  utmSource = getUtmSource();

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击修改渠道
   * @param channelId
   */
  onChangeChannel = channelId => {
    this.channelId = channelId;
  };
  /**
   * 点击执行预约
   */
  @lockAsync()
  onExecuteAppointment = async () => {
    $$tracker.clickLjyy();
    if (this.checkValidate() && !this.submitLock) {
      this.submitLock = true;
      if (this.startTime) {
        this.endTime = new Date(); // 获取当前时间
        const timeDiff = (this.endTime - this.startTime) / 1000; // 毫秒转为秒
        this.totalTime = timeDiff;
        console.log('经过时间：' + timeDiff + '秒');
      }
      await this.executeAppointment.run();
    } else {
    }
  };

  /**
   * 点击同意协议状态
   */
  clickProtocol = () => {
    this.protocolCheckState = !this.protocolCheckState;
    // $$tracker.clickStartPact();
  };

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.appointmentSuccessState = false;
    sessionStorage.removeItem('smsFirstTimes');
    this.emailInputStore.onChange('');
    this.smsInputStore.onChange('');
    this.clearStyle();
    clearInterval(this.appointmentSuccessTimer);
  };
  /**
   * 校验输入
   * @returns {boolean}
   */
  checkValidate = () => {
    let validate = false;

    if (!this.emailInputStore.value) {
      this.emailInputError = getLocales('reserve.logic.need_email');
    } else if (!this.smsInputStore.value) {
      this.smsInputError = getLocales('reserve.logic.need_vcode');
    } else if (!this.protocolCheckState) {
      message.error(getLocales('reserve.logic.need_agreement'));
    } else {
      validate = true;
    }
    return validate;
  };

  /**
   * 发送验证码
   * @param authParams
   * @returns {Promise<boolean>}
   */
  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  async onSendVCRequest({ ...authParams }) {
    try {
      await this.onGetEmailCode.run({ email: this.emailInputStore.value, ...authParams, pass_check: 1 });
      console.log('发送验证码');
      $$tracker.clickYzm();
      return true;
    } catch (err) {
      // message.error(err.message);
      return false;
    }
  }

  // 预约成功处理
  onAppointmentSuccess = () => {
    // this.appointmentSuccessState = true;
    this.updataConfig();
    this.appointmentSuccessCallBack(this.emailInputStore.value);
    this.onClickClose();

    // clearInterval(this.appointmentSuccessTimer);
    // this.appointmentSuccessTimer = setInterval(() => {
    //   if (this.appointmentSuccessCloseTime <= 0) {
    //     clearInterval(this.appointmentSuccessTimer);
    //     this.onClickClose();
    //     return false;
    //   }
    //   this.appointmentSuccessCloseTime = this.appointmentSuccessCloseTime - 1;
    // }, 1000);
  };

  /**
   * 初始化数据
   */
  reInitState = () => {
    this.appointmentSuccessState = false;
    this.channelId = '';
    this.smsInputStore.onChange('');
    this.emailInputStore.onChange('');
  };
  // 获取手机验证码
  onGetEmailCodeAsync = params => {
    return this.$ztService.getEmailCode(params);
  };
  // 预约请求发送
  appointmentAsync = () => {
    return this.$ztService.subscribe(this.emailInputStore.value, this.smsInputStore.value, '1219DLC', 1, this.totalTime);
  };

  // 清除预约时间变量
  clearTimeStyle = () => {
    this.startTime = null;
    this.endTime = null;
    this.isTimerStarted = false;
    this.totalTime = 0;
  };

  use() {
    super.use();
    this.executeAppointment = useRequest(async () => await this.appointmentAsync(), {
      manual: true,
      onSuccess: data => {
        console.log('预约成功', data);
        this.is_new = !!data.is_new;
        this.onAppointmentSuccess();
        this.submitLock = false;
        this.clearTimeStyle();
        // $$tracker.clickReserveSubmit('success', this.emailInputStore.value, this.currentChannelId, '');
        // semTracker.send({
        //   eventId: 'btForm'
        // });
      },
      onError: e => {
        e.serviceResponse?.message && AntdMessage.error(e.serviceResponse?.message);
        this.submitLock = false;
        // $$tracker.clickReserveSubmit('fail', this.emailInputStore.value, this.currentChannelId, e.serviceResponse?.message);
      }
    });
    this.onGetEmailCode = useRequest(async params => await this.onGetEmailCodeAsync(params), {
      manual: true,
      onSuccess: data => {
        console.log('获取验证码', data);
      },
      onError: e => {
        console.log('获取验证码失败', e);
        e.serviceResponse?.message && AntdMessage.error(e.serviceResponse?.message);
      }
    });
    useEffect(
      () => {
        if (this.executeAppointment.data) {
          // $$tracker.clickStartDone('success', '', this.emailInputStore.value);
        }
      },
      [this.executeAppointment.data]
    );
    useEffect(
      () => {
        if (this.executeAppointment.error) {
          // $$tracker.clickStartDone('fail', this.executeAppointment.error.message);
        }
      },
      [this.executeAppointment.error]
    );
    useEffect(
      () => {
        if (this.onGetEmailCode.data) {
          // $$tracker.clickStartCode('success', '');
        }
      },
      [this.onGetEmailCode.data]
    );
    useEffect(
      () => {
        if (this.onGetEmailCode.error) {
          // $$tracker.clickStartCode('fail', this.onGetEmailCode.error.message);
        }
      },
      [this.onGetEmailCode.error]
    );
    useMount(() => {
      // 二次删除重复发送状态
      console.log(this.emailInputStore);
      sessionStorage.removeItem('smsFirstTimes');
    });

    useUnmount(() => {
      this.clearTimeStyle();
    });

    // 只有当第一次输入时才启动计时。
    useEffect(
      () => {
        if (this.emailInputStore.value && !this.isTimerStarted) {
          this.startTime = new Date(); // 获取当前时间
          console.log('计时开始：' + this.startTime);
          this.isTimerStarted = true;
        }
      },
      [this.emailInputStore.value, this.isTimerStarted]
    );

    useEffect(
      () => {
        if (!!this.emailInputStore.value) {
          this.emailInputError = '';
        }
      },
      [this.emailInputStore.value]
    );
    useEffect(
      () => {
        if (!!this.smsInputStore.value) {
          this.smsInputError = '';
        }
      },
      [this.smsInputStore.value]
    );
    useEffect(
      () => {
        this.emailTipsStore.inputValue = this.emailInputStore.value;
      },
      [this.emailInputStore.value]
    );
    useEffect(
      () => {
        this.emailInputStore.value = this.emailTipsStore.value.value;
      },
      [this.emailTipsStore.value]
    );
    useEffect(() => {
      return () => {
        this.emailTipsStore.inputValue = '';
        this.emailTipsStore.value = '';
      };
    }, []);
    useEffect(
      () => {
        const inputRef = this.emailInputStore.elementRef.current;

        if (inputRef) {
          const focus = e => {
            if (e.target.value) {
              this.emailTipsStore.active = true;
            } else {
              this.emailTipsStore.active = false;
            }
          };
          const blur = () => {
            setTimeout(() => {
              this.emailTipsStore.active = false;
            }, 300);
          };
          inputRef.addEventListener('input', focus);
          inputRef.addEventListener('blur', blur);
          return () => {
            inputRef.removeEventListener('keydown', focus);
            inputRef.removeEventListener('blur', blur);
          };
        }
      },
      [this.emailInputStore.elementRef.current]
    );
  }
}

export default AppointmentModalStore;
